<template lang="pug">
.card(:class="[`card--${padding}`, { 'card--elevated': elevated, 'card--interactive': interactive }]")
  .card__title(v-if="title") {{ title }}
  .card__body
    slot
</template>

<script>
export default {
  props: {
    title: String,
    padding: {
      type: String,
      default: "md",
      validator: (value) => ["sm", "md", "lg"].indexOf(value) !== -1,
    },
    elevated: {
      type: Boolean,
      default: false,
    },
    interactive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  @apply bg-white;
  @apply rounded-xl;
  @apply border;
  @apply border-bluegray-100;
  @apply shadow-bluegray-400-lg;
  @apply relative;
  @apply transition-all;
  @apply duration-200;

  &--sm {
    @apply p-3;
  }

  &--md {
    @apply p-4;
  }

  &--lg {
    @apply p-6;
    @screen sm {
      @apply p-8;
    }
  }

  &--elevated {
    @apply rounded-2xl;
    @apply shadow-bluegray-400-xl;
  }

  &--interactive {
    @apply cursor-pointer;
    &:hover {
      @apply shadow-bluegray-400-xl;
      @apply border-bluegray-200;
    }
  }

  &__body {
    @apply h-full;
  }

  &__title {
    @apply font-semibold;
    @apply text-bluegray-500;
    @apply text-2xl;
    @apply mb-3;
  }
}
</style>
